import React from 'react';
import dayjs from 'dayjs';
import {
    allTimeTimeRange,
    lastSevenDaysTimeRange,
    thisMonthTimeRange,
    todayTimeRange,
    yesterdayTimeRange,
} from '../utils/constant';

export function useOrderTimeRange(initialRange = allTimeTimeRange) {
    const [timeRange, setTimeRange] = React.useState(initialRange);
    const [dateFrom, setDateFrom] = React.useState(() => dayjs(initialRange.from));
    const [dateTo, setDateTo] = React.useState(() => dayjs(initialRange.to));

    const applyTimeRange = React.useCallback((range) => {
        setTimeRange(range);
        setDateFrom(dayjs(range.from));
        setDateTo(dayjs(range.to));
    }, []);

    const handleDateChange = React.useCallback((newValue, key) => {
        if (!newValue) {
            return;
        }

        const formatted = newValue.format('YYYY-MM-DD HH:mm:ss.SSS');

        if (key === 'from') {
            setDateFrom(newValue);
            setTimeRange((prev) => ({ ...prev, from: formatted }));
            return;
        }

        setDateTo(newValue);
        setTimeRange((prev) => ({ ...prev, to: formatted }));
    }, []);

    const filterItems = React.useMemo(() => [
        {
            label: "Today",
            onClick: () => applyTimeRange(todayTimeRange),
        },
        {
            label: "Yesterday",
            onClick: () => applyTimeRange(yesterdayTimeRange),
        },
        {
            label: "Last 7 days",
            onClick: () => applyTimeRange(lastSevenDaysTimeRange),
        },
        {
            label: "This month",
            onClick: () => applyTimeRange(thisMonthTimeRange),
        },
        {
            label: "All time",
            onClick: () => applyTimeRange(allTimeTimeRange),
        },
    ], [applyTimeRange]);

    return { timeRange, dateFrom, dateTo, handleDateChange, filterItems };
}
